import { useState } from 'react';

import {
  Dialog,
  MenuItem,
  TextField,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { sanitizeHTML } from 'utils/helpers';

import { SuggestedMessagesTemplates } from 'services/suggestedMessages/types';

import { SuggestedMessagesSetupProps } from './types';

import * as S from './styles';

const SuggestedMessagesSetup: React.FC<SuggestedMessagesSetupProps> = ({
  open,
  messageTemplates,
  onSubmit,
}) => {
  const [selectedTemplate, setSelectedTemplate] =
    useState<SuggestedMessagesTemplates>(messageTemplates[0]);

  const { formatMessage } = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog
      open={open && messageTemplates.length > 0}
      maxWidth="md"
      fullWidth
      fullScreen={isMobile}
      data-testid="suggestedMessagesSetupModal"
    >
      <S.Container>
        <S.Illustration />
        <S.Title>
          <FormattedMessage id="MESSAGETIPS.MODALNEWS.TITLE" />
        </S.Title>

        <S.ContentContainer>
          <S.Subtitle>
            <FormattedMessage
              id="MESSAGETIPS.MODALNEWS.SUBTITLE"
              values={{
                b: (chunk: string) => <b>{chunk}</b>,
              }}
            />
          </S.Subtitle>

          <S.SubtitleStyle>
            <FormattedMessage id="MESSAGETIPS.MODALNEWS.SUBTITLESTYLE" />
          </S.SubtitleStyle>

          <TextField
            select
            fullWidth
            label={formatMessage({ id: 'MESSAGETIPS.MODALNEWS.LABELTITLE' })}
            value={selectedTemplate.id}
            onChange={e => {
              const selectedId = Number(e.target.value);
              setSelectedTemplate(
                messageTemplates.find(
                  mt => mt.id === selectedId,
                ) as SuggestedMessagesTemplates,
              );
            }}
          >
            {messageTemplates.map(messageTemplate => (
              <MenuItem key={messageTemplate.id} value={messageTemplate.id}>
                {messageTemplate.tags.tone_of_voice}
              </MenuItem>
            ))}
          </TextField>

          <S.MessagePreviewContainer data-testid="messagePreviewContainer">
            <S.MessagePreviewText
              dangerouslySetInnerHTML={sanitizeHTML(selectedTemplate.message, {
                ALLOWED_TAGS: ['b'],
                ALLOWED_ATTR: [],
              })}
              // using dangerouslySetInnerHTML to replace tags like <b>
            />
          </S.MessagePreviewContainer>
        </S.ContentContainer>

        <S.SubmitButton
          type="button"
          onClick={() => onSubmit(selectedTemplate.id)}
        >
          <FormattedMessage id="MESSAGETIPS.MODALNEWS.BUTTON" />
        </S.SubmitButton>
      </S.Container>
    </Dialog>
  );
};

export default SuggestedMessagesSetup;
